interface LoadingProps {
  absolute?: boolean;
}

export function Loading({ absolute = false }: LoadingProps) {
  return (
    <div
      className={`flex bg-neutral-200 space-x-2 justify-center items-center bg-white h-full ${absolute ? 'absolute w-full h-full opacity-65' : 'relative opacity-100'}`}
    >
      <span className="sr-only">Loading...</span>
      <div className="h-8 w-8 bg-primary-500 rounded-full animate-bounce [animation-delay:-0.3s] shadow" />
      <div className="h-8 w-8 bg-primary-500 rounded-full animate-bounce [animation-delay:-0.15s] shadow" />
      <div className="h-8 w-8 bg-primary-500 rounded-full animate-bounce shadow" />
    </div>
  );
}
